import type { IconData } from '@stacksjs/iconify-core'

export const sl1x1: IconData = {
  "body": "<defs><clipPath id=\"SVGOmW22cGh\"><rect width=\"384\" height=\"512\" rx=\"4.6\" ry=\"7.6\"/></clipPath></defs><g fill-rule=\"evenodd\" clip-path=\"url(#SVGOmW22cGh)\" transform=\"scale(1.33333 1)\"><path fill=\"#0000cd\" d=\"M0 341.7h512V512H0z\"/><path fill=\"#fff\" d=\"M0 171.4h512v170.3H0z\"/><path fill=\"#00cd00\" d=\"M0 0h512v171.4H0z\"/></g>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default sl1x1
